"use strict";

window.Vue = require('vue');

import './elements/form';
import './elements/tracker';